module.exports = __webpack_public_path__ + "3de3350819de1c8bff5bdd8fc38ec112.svg";